import { useSearchParams } from "react-router-dom";
import { useMemo } from "react";

export interface ISummaryFiltersFromURL {
  entriesType: string;
  logbook: string[];
  ref: string | undefined;
  status: number[];
  page: number;
  sort?: string;
  dir?: string;
  dateFrom?: string;
  dateTo?: string;
  dateType: string;
  hasSnapshot: boolean;
  hasAttachments: boolean;
  hasChecklists: boolean;
}

export const useSummaryFilters = (): ISummaryFiltersFromURL => {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const logbooks = searchParams.getAll("logbook");
    const statuses = searchParams.getAll("status");

    return {
      entriesType: searchParams.get("entriesType") || "all",
      logbook: logbooks.length > 0 ? logbooks : ["*"],
      status: statuses.length > 0 ? statuses.map(s => Number(s)) : [1],
      page: Number(searchParams.get("page")) || 1,
      sort: searchParams.get("sort") || undefined,
      dir: (searchParams.get("dir") as "asc" | "desc") || undefined,
      dateFrom: searchParams.get("dateFrom") || undefined,
      dateTo: searchParams.get("dateTo") || undefined,
      dateType: searchParams.get("dateType") || "entrydate",
      hasSnapshot: !!searchParams.get("hasSnapshot"),
      hasAttachments: !!searchParams.get("hasAttachments"),
      hasChecklists: !!searchParams.get("hasChecklists"),
      ref: searchParams.get("ref") || undefined,
    };
  }, [searchParams]);
};
